import { lazy } from 'react';

// project imports
import ProfileLayout from "../layout/ProfileLayout";
import Loadable from 'ui-component/Loadable';

// sample page routing
const Profileuser = Loadable(lazy(() => import('views/profile/profileUser')));
const ProfileGren = Loadable(lazy(() => import('views/profile/profileGren')));
const ProfileText2Img = Loadable(lazy(() => import('views/profile/profileText2Img')));
const ProfileImg2img = Loadable(lazy(() => import('views/profile/profileImg2img')));
const ProfilePartial2img = Loadable(lazy(() => import('views/profile/profilePartial2img')));
const ProfileCollect = Loadable(lazy(() => import('views/profile/profileCollect')));
const ProfileRecord = Loadable(lazy(() => import('views/profile/profileRecord')))

// ==============================|| Profile ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: <ProfileLayout />,
  children: [
    {
      path: '/profile',
      children: [
        {
          path: '',
          element: <Profileuser />,
        },
        {
          path: 'user',
          element: <Profileuser />,
        },
        {
          path: 'generating',
          element: <ProfileGren />,
        },
        {
          path: 'text2img',
          element: <ProfileText2Img />,
        },
        {
          path: 'img2img',
          element: <ProfileImg2img />,
        },
        {
          path: 'partial2img',
          element: <ProfilePartial2img />,
        },
        {
          path: 'collect',
          element: <ProfileCollect />,
        },
        {
          path: 'record',
          element: <ProfileRecord />,
        }
      ]
    }
  ]
};

export default MainRoutes;
